<template>
  <div class="page new-ticket">
    <header>
      <div @click="back" tabindex="0" @keypress.space="back" class="back-btn"><i class="fa fa-fw fa-chevron-left"></i></div>
      <div class="view-title">{{ 'recover' | lang }}</div>
    </header>
    <div>
      <div class="small-form">
        <p>{{ 'RecoveryPasswordHelp' | lang }}</p>
        <div class="floating-label">
          <input v-model="email" placeholder=" " type="text" :class="{ invalid: invalidEmail }" />
          <label>{{ 'Email' | lang }}</label>
        </div>
        <div v-if="status">
          <div v-if="status === 'waiting'">
            <i class="fa fa-fw fa-refresh fa-spin"></i>{{ 'pleaseWait' | lang }}
          </div>
          <div v-else-if="status === 'error'" class="text-red">
            <i class="fa fa-fw fa-exclamation-triangle"></i>{{ 'errorOccured' | lang }}
          </div>
          <div v-else-if="status === 'success'" class="text-green">
            <i class="fa fa-fw fa-check"></i>{{ 'reset_password_required' | lang }}
          </div>
        </div>
      </div>
    </div>
    <footer>
      <button class="full-width" @click="recover" :disabled="invalidEmail || isWaiting || status === 'success'">{{ 'recover' | lang }}</button>
    </footer>
  </div>
</template>

<script>
import page from '@/mixins/routeControl'
import UserServices from '@/mixins/services/userServices'

export default {
  name: 'PasswordRecovery',
  mixins: [ page, UserServices ],
  data () {
    return {
      email: '',
      status: ''
    }
  },
  computed: {
    invalidEmail () {
      return !this.checkEmailValidity(this.email)
    },
    isWaiting () {
      return this.status === 'waiting'
    }
  },
  methods: {
    recover () {
      this.showPassword = false
      this.status = 'waiting'
      this._askPasswordReinitialization(this.email).then(data => {
        this.status = 'success'
        console.log(data)
        /* setTimeout(() => {
          this.goTo(this.waitingLoginPage, true, true)
          this.waitingLoginPage = null
        }, 700) */
      }).catch(err => {
        this.status = 'error'
        console.log(err)
      })
    }
  },
  beforeDestroy () {},
  mounted () {},
  watch: {}
}
</script>

<style></style>
